import type {
  ChatsChannelBase,
  ChatsChannelSetting
} from '../../../constants/types';
import { ChatsChannelType } from '../../../constants/types';
import { getChatIcon } from '../../helpers';

export const getInstagramSettings = ({
  instagramAccountId
}: Partial<ChatsChannelBase>) => {
  if (!instagramAccountId) return null;

  const parsedUserAccount = instagramAccountId?.replace(/@/gm, '');
  const url = `https://ig.me/m/${parsedUserAccount}`;

  return {
    provider: ChatsChannelType.instagram,
    link: { url },
    title: 'Instagram',
    icon: getChatIcon(ChatsChannelType.instagram),
    color: 'rgb(1, 149, 246)'
  } as ChatsChannelSetting;
};
